import { render, staticRenderFns } from "./AnonBar.vue?vue&type=template&id=118818c3&scoped=true&"
import script from "./AnonBar.vue?vue&type=script&lang=ts&"
export * from "./AnonBar.vue?vue&type=script&lang=ts&"
import style0 from "./AnonBar.vue?vue&type=style&index=0&id=118818c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118818c3",
  null
  
)

export default component.exports